<!--
 * @Description: 导出邮件提示对话框
 * @Author: shh
 * @Date: 2026-06-18
-->
<template>
  <el-dialog class="export-email-dialog" width="354px" title="提示"
    :visible.sync="visible" :close-on-click-modal="false" @open="initData"
    :before-close="handleCancel" center>
    <el-form ref="exportEmailTipRef" :model="exportEmailTipForm" :rules="rules" class="dialog-body">
      <div class="email-tip">
        <i class="el-icon-warning"></i>
        <span class="tip-text">文件发送至</span>
      </div>
      <el-form-item prop="email">
        <el-input v-model.trim="exportEmailTipForm.email" size="small" placeholder="请输入邮箱" 
          maxlength="100">
				</el-input>
      </el-form-item>
      <div style="margin: 0 0 15px 27px;">
        <el-checkbox v-model="exportEmailTipForm.updateEmail" :true-label="1" :false-label="0">
          更新为管理员邮箱
        </el-checkbox>
      </div>
    </el-form>
    <div class="dialog-footer bk-wizard-bottons">
       <el-button @click="handleCancel">取 消</el-button>
       <el-button type="primary" @click="handleExport">导 出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
export default {
  name: 'ExportEmailTipDlg',

  props: ['visible', 'exportParam', 'email'],

  data() {
    let validateEmail = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入邮箱'))
			} else if (!Util.validateEmail(value)) {
				callback(new Error('邮箱格式不正确'))
			} else {
				callback()
			}
		}
    return {
      exportEmailTipForm: {
        email: '',
        updateEmail: 0
      },
      rules: {
				email: [{required: true, validator: validateEmail, trigger: 'blur'}],
      }
    }
  },

  methods: {
    initData() {
      this.exportEmailTipForm.email = this.email || '';
    },

    exportConfirmTips(msg) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        this.clearVaild();
        this.$emit("close-dialog", true);
      })
    },

    clearVaild() {
      this.exportEmailTipForm.updateEmail = 0;
      this.exportEmailTipForm.email = '';
			this.$nextTick(() => {
				this.$refs["exportEmailTipRef"].clearValidate();
			});
		},

    handleExport() {
      this.$refs.exportEmailTipRef.validate((valid) => {
        if (!valid) return false;
        let param = {...this.exportParam};
        this.$set(param, 'updateEmail', this.exportEmailTipForm.updateEmail);
        this.$set(param, 'email', this.exportEmailTipForm.email);
        let requestData = {
          method: 'GET', 
          url: Constant.URL_EXPORT_ORDER_LIST_2EXCEL,
          param: param,
          contentType: this.commonConst.CNTYPE_URLENCODED
        };
        this.vueRequest(requestData).then(result => {
          if (result == null) {
            return;
          }
          this.exportConfirmTips(result.data);
        })
      });
    },

    handleCancel() {
      this.clearVaild();
      this.$emit("close-dialog", false);
    },
  }
}
</script>

<style scoped>
.export-email-dialog .dialog-body {
  padding: 0px 25px;
}

.export-email-dialog .email-tip {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.export-email-dialog .email-tip i {
  font-size: 20px;
  color: #E6A23C;
  margin: 0px 7px 0px 0px;
}

.export-email-dialog .tip-text {
  font-size: 13px;
  color: #666666;
}

.export-email-dialog .dialog-footer {
  padding-right: 25px;
  text-align: right;
}
</style>
<style>
.export-email-dialog .el-form-item {
  margin-bottom: 15px;
}

.export-email-dialog .el-form-item__content {
  margin-left: 27px !important;
}

.export-email-dialog .el-dialog--center .el-dialog__body {
  padding: 20px 0 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/report/components/ExportEmailTipDlg.vue